// extracted by mini-css-extract-plugin
export var col = "formula-module--col--cf57f";
export var formula = "formula-module--formula--23baf";
export var formula__content = "formula-module--formula__content--e1856";
export var rails = "formula-module--rails--d499d";
export var railway = "formula-module--railway--6636f";
export var railwayScroll = "formula-module--railway-scroll--a5eaf";
export var row = "formula-module--row--70bec";
export var rowNoMrg = "formula-module--row-no-mrg--39273";
export var smoke = "formula-module--smoke--3bfeb";
export var swipe = "formula-module--swipe--31653";
export var train1 = "formula-module--train-1--6f15b";
export var train2 = "formula-module--train-2--51c1e";
export var train3 = "formula-module--train-3--2e0eb";
export var train4 = "formula-module--train-4--6d7b3";
export var trainCol = "formula-module--train-col--f3dd2";